import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: "us-east-1_j9J5Zdmg4",
  ClientId: "2nof8hkh3rp9pdf7intqv829k3",
};

export default new CognitoUserPool(poolData);
